module.exports = __webpack_public_path__ + "img/slider-arrow-r.95ce30b5.svg";